import { render, staticRenderFns } from "./PDPDiscussionTabs.vue?vue&type=template&id=3878e84e&scoped=true&"
import script from "./PDPDiscussionTabs.vue?vue&type=script&lang=js&"
export * from "./PDPDiscussionTabs.vue?vue&type=script&lang=js&"
import style0 from "./PDPDiscussionTabs.vue?vue&type=style&index=0&id=3878e84e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878e84e",
  null
  
)

export default component.exports